import { getErrorData, isGenericError } from './errorMapping'

const handleAddBillError = (
  error,
  lang,
  setSystemError,
  setFieldsValidationError,
  setPageErrorMsg,
  setFieldLevelErrorData
) => {
  if (error && isGenericError({ error })) {
    setSystemError(true)
  } else if (error) {
    const { message, fieldErrorData } = getErrorData({
      error,
      pageName: 'addEditErrors'
    })

    if (message !== '') {
      if (fieldErrorData?.filedName === 'zipcode') {
        // getZipcodeDOM(
        //   '#be1324',
        //   `${getErrorIcon()} ${lang[fieldErrorData?.messageKey]}`
        // )
        setFieldLevelErrorData(fieldErrorData)
      } else {
        setFieldLevelErrorData(fieldErrorData)
      }
      setPageErrorMsg(message)
      setFieldsValidationError(true)
    } else {
      setSystemError(true)
    }
  }
}

export default handleAddBillError
